export const legalTranslations = {
  fr: {
    privacy: {
      title: 'Politique de confidentialité',
      updated: 'Dernière mise à jour : juin 2026',
      intro: "La présente Politique de confidentialité décrit la manière dont Stéphanie Ruiz (« Comprendre qui l'on est ») collecte et traite vos données personnelles, conformément au Règlement Général sur la Protection des Données (RGPD – UE 2016/679) et à la réglementation espagnole applicable (LOPDGDD).",
      sections: [
        {
          heading: '1. Responsable du traitement',
          paragraphs: [
            'Stéphanie Ruiz – Travailleuse indépendante (autónoma) en Espagne.',
            'Adresse : Sant Josep de Sa Talaia, Ibiza, Îles Baléares (Espagne).',
            'Email : contact@comprendre-qui-on-est.com — Tél. : +34 608 414 296'
          ]
        },
        {
          heading: '2. Données collectées',
          paragraphs: ['Nous collectons uniquement les données que vous nous transmettez volontairement :'],
          items: [
            'via le test de découverte : prénom, adresse email, langue, et le profil/résultat obtenu ;',
            'via le formulaire de contact : nom, adresse email, contenu de votre message ;',
            'via la prise de rendez-vous (Calendly) : nom, email et informations renseignées pour réserver un créneau.'
          ]
        },
        {
          heading: '3. Finalités du traitement',
          paragraphs: ['Vos données sont utilisées pour :'],
          items: [
            'vous transmettre le résultat de votre test et des informations en lien avec votre démarche ;',
            'répondre à vos demandes de contact et organiser vos rendez-vous ;',
            'assurer le suivi de notre relation et, le cas échéant, vous recontacter.'
          ],
          after: "Aucune décision automatisée ni profilage à but publicitaire n'est réalisé. Vos données ne sont jamais vendues."
        },
        {
          heading: '4. Base légale',
          paragraphs: ["Le traitement repose sur votre consentement (case à cocher lors de l'envoi des formulaires) et, le cas échéant, sur l'intérêt légitime à répondre à vos demandes."]
        },
        {
          heading: '5. Destinataires et sous-traitants',
          paragraphs: ['Vos données sont traitées par Stéphanie Ruiz. Pour le bon fonctionnement du site, nous faisons appel à des prestataires techniques agissant comme sous-traitants :'],
          items: [
            'SendGrid (Twilio Inc.) : envoi des emails de notification et de confirmation ;',
            'Calendly : gestion des prises de rendez-vous ;',
            'Emergent : hébergement du site.'
          ],
          after: 'Ces prestataires peuvent être situés hors de l\'Union européenne ; dans ce cas, les transferts sont encadrés par des garanties appropriées (clauses contractuelles types).'
        },
        {
          heading: '6. Durée de conservation',
          paragraphs: ['Vos données sont conservées pendant 3 ans à compter de notre dernier contact, puis supprimées ou anonymisées, sauf obligation légale contraire.']
        },
        {
          heading: '7. Vos droits',
          paragraphs: ["Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité de vos données. Vous pouvez exercer ces droits à tout moment en écrivant à contact@comprendre-qui-on-est.com. Vous pouvez également introduire une réclamation auprès de l'autorité de contrôle compétente (en Espagne : l'AEPD – www.aepd.es)."]
        },
        {
          heading: '8. Sécurité',
          paragraphs: ['Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé.']
        },
        {
          heading: '9. Cookies',
          paragraphs: ['Ce site n\'utilise pas de cookies publicitaires ou de suivi marketing. Seuls des cookies techniques strictement nécessaires (et ceux liés au widget Calendly) peuvent être déposés.']
        }
      ]
    },
    notice: {
      title: 'Mentions légales',
      updated: 'Dernière mise à jour : juin 2026',
      intro: '',
      sections: [
        {
          heading: 'Éditeur du site',
          paragraphs: [
            'Le présent site est édité par Stéphanie Ruiz, travailleuse indépendante (autónoma) en Espagne.',
            'Activité : Numérologue, coach de vie, accompagnement familial et de couple.',
            'Adresse professionnelle : Sant Josep de Sa Talaia, Ibiza, Îles Baléares (Espagne).',
            'Email : contact@comprendre-qui-on-est.com — Téléphone : +34 608 414 296'
          ]
        },
        {
          heading: 'Directrice de la publication',
          paragraphs: ['Stéphanie Ruiz']
        },
        {
          heading: 'Nom de domaine',
          paragraphs: ['comprendre-qui-on-est.com']
        },
        {
          heading: 'Hébergement',
          paragraphs: ['Le site est hébergé par Emergent (Emergent Labs).']
        },
        {
          heading: 'Propriété intellectuelle',
          paragraphs: ["L'ensemble des contenus du site (textes, images, logo, éléments graphiques) est protégé par le droit d'auteur. Toute reproduction, totale ou partielle, sans autorisation préalable est interdite."]
        },
        {
          heading: 'Responsabilité',
          paragraphs: ["Les informations et accompagnements proposés sur ce site ne se substituent en aucun cas à un avis, diagnostic ou traitement médical, psychologique ou psychiatrique."]
        }
      ]
    }
  },

  es: {
    privacy: {
      title: 'Política de Privacidad',
      updated: 'Última actualización: junio 2026',
      intro: 'Esta Política de Privacidad describe cómo Stéphanie Ruiz («Comprender quién eres») recopila y trata tus datos personales, de conformidad con el Reglamento General de Protección de Datos (RGPD – UE 2016/679) y la normativa española aplicable (LOPDGDD).',
      sections: [
        {
          heading: '1. Responsable del tratamiento',
          paragraphs: [
            'Stéphanie Ruiz – Trabajadora autónoma en España.',
            'Dirección: Sant Josep de Sa Talaia, Ibiza, Islas Baleares (España).',
            'Email: contact@comprendre-qui-on-est.com — Tel.: +34 608 414 296'
          ]
        },
        {
          heading: '2. Datos recopilados',
          paragraphs: ['Solo recopilamos los datos que nos facilitas voluntariamente:'],
          items: [
            'mediante el test de descubrimiento: nombre, correo electrónico, idioma y el perfil/resultado obtenido;',
            'mediante el formulario de contacto: nombre, correo electrónico, contenido de tu mensaje;',
            'mediante la reserva de cita (Calendly): nombre, email e información indicada para reservar.'
          ]
        },
        {
          heading: '3. Finalidad del tratamiento',
          paragraphs: ['Tus datos se utilizan para:'],
          items: [
            'enviarte el resultado de tu test e información relacionada con tu proceso;',
            'responder a tus solicitudes de contacto y organizar tus citas;',
            'realizar el seguimiento de nuestra relación y, si procede, volver a contactarte.'
          ],
          after: 'No se realiza ninguna decisión automatizada ni elaboración de perfiles con fines publicitarios. Tus datos nunca se venden.'
        },
        {
          heading: '4. Base jurídica',
          paragraphs: ['El tratamiento se basa en tu consentimiento (casilla de verificación al enviar los formularios) y, en su caso, en el interés legítimo de responder a tus solicitudes.']
        },
        {
          heading: '5. Destinatarios y encargados del tratamiento',
          paragraphs: ['Tus datos son tratados por Stéphanie Ruiz. Para el funcionamiento del sitio recurrimos a proveedores técnicos que actúan como encargados del tratamiento:'],
          items: [
            'SendGrid (Twilio Inc.): envío de correos de notificación y confirmación;',
            'Calendly: gestión de las reservas de cita;',
            'Emergent: alojamiento del sitio web.'
          ],
          after: 'Estos proveedores pueden estar ubicados fuera de la Unión Europea; en tal caso, las transferencias se rigen por garantías adecuadas (cláusulas contractuales tipo).'
        },
        {
          heading: '6. Plazo de conservación',
          paragraphs: ['Tus datos se conservan durante 3 años desde nuestro último contacto y luego se eliminan o anonimizan, salvo obligación legal en contrario.']
        },
        {
          heading: '7. Tus derechos',
          paragraphs: ['De acuerdo con el RGPD, tienes derecho de acceso, rectificación, supresión, limitación, oposición y portabilidad de tus datos. Puedes ejercerlos en cualquier momento escribiendo a contact@comprendre-qui-on-est.com. También puedes presentar una reclamación ante la autoridad de control (en España: la AEPD – www.aepd.es).']
        },
        {
          heading: '8. Seguridad',
          paragraphs: ['Aplicamos medidas técnicas y organizativas adecuadas para proteger tus datos frente a accesos no autorizados.']
        },
        {
          heading: '9. Cookies',
          paragraphs: ['Este sitio no utiliza cookies publicitarias ni de seguimiento de marketing. Solo pueden instalarse cookies técnicas estrictamente necesarias (y las asociadas al widget de Calendly).']
        }
      ]
    },
    notice: {
      title: 'Aviso Legal',
      updated: 'Última actualización: junio 2026',
      intro: '',
      sections: [
        {
          heading: 'Titular del sitio web',
          paragraphs: [
            'Este sitio web es editado por Stéphanie Ruiz, trabajadora autónoma en España.',
            'Actividad: Numeróloga, coach de vida, acompañamiento familiar y de pareja.',
            'Dirección profesional: Sant Josep de Sa Talaia, Ibiza, Islas Baleares (España).',
            'Email: contact@comprendre-qui-on-est.com — Teléfono: +34 608 414 296'
          ]
        },
        {
          heading: 'Responsable de la publicación',
          paragraphs: ['Stéphanie Ruiz']
        },
        {
          heading: 'Nombre de dominio',
          paragraphs: ['comprendre-qui-on-est.com']
        },
        {
          heading: 'Alojamiento',
          paragraphs: ['El sitio está alojado por Emergent (Emergent Labs).']
        },
        {
          heading: 'Propiedad intelectual',
          paragraphs: ['Todos los contenidos del sitio (textos, imágenes, logotipo, elementos gráficos) están protegidos por derechos de autor. Queda prohibida cualquier reproducción, total o parcial, sin autorización previa.']
        },
        {
          heading: 'Responsabilidad',
          paragraphs: ['La información y los acompañamientos ofrecidos en este sitio no sustituyen en ningún caso un consejo, diagnóstico o tratamiento médico, psicológico o psiquiátrico.']
        }
      ]
    }
  }
};
